import React, { FC } from 'react';
import { MenuRow } from '../../MenuRow';
import styles from './ColorFilterRow.scss';
import { IOuter } from './ColorFilterRow.types';

export const ColorFilterRow: FC<IOuter> = ({
  label,
  labelVerticalAlignment = 'middle',
  colors,
  isActive,
  dataHook,
}) => (
  <tr className={styles.component} data-hook={dataHook}>
    <td
      style={{
        verticalAlign: labelVerticalAlignment,
        paddingTop: labelVerticalAlignment === 'top' ? 9 : 0,
      }}
    >
      <MenuRow text={label} active={isActive} />
    </td>
    <td className={styles.colorsContainer}>{colors}</td>
  </tr>
);
